import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Diagram: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_31568)'>
        <path
          d='M23 12C23 5.93459 18.0654 1 12 1C9.59714 1 7.3164 1.7614 5.39998 3.2C3.03498 4.97546 1.46659 7.66621 1.09281 10.5812C1.03094 11.0427 1 11.5205 1 12C1 14.708 1.99258 17.3084 3.79378 19.3236C5.88207 21.6602 8.87183 23 12 23C16.5074 23 20.5096 20.3006 22.199 16.125C22.7318 14.8179 23 13.4326 23 12ZM22.5162 12C22.5162 13.2873 22.2893 14.5368 21.839 15.7175L16.4516 13.5373C16.6235 13.0466 16.7094 12.5301 16.7094 11.9999C16.7094 9.40189 14.5971 7.28968 11.9992 7.28968C11.0531 7.28968 10.149 7.56725 9.37222 8.09232L7.65861 5.80895L5.88572 3.44395C7.67751 2.16177 9.78478 1.48371 12.0002 1.48371C17.7992 1.48371 22.5164 6.20072 22.5164 11.9999L22.5162 12ZM8.84514 14.8136C8.15421 14.0367 7.7735 13.0364 7.7735 12C7.7735 11.8238 7.78467 11.6416 7.80873 11.4568C7.95397 10.3345 8.55638 9.30067 9.4656 8.62083C10.2004 8.06826 11.0761 7.77607 12 7.77607C14.3298 7.77607 16.2264 9.67271 16.2264 12.0025C16.2264 12.5525 16.1233 13.0853 15.9188 13.5846C15.27 15.1908 13.7317 16.2272 12.0008 16.2272C10.8011 16.2264 9.65034 15.7116 8.84514 14.8136ZM5.49871 3.73459L8.98616 8.38297C8.1414 9.08679 7.56476 10.0768 7.36709 11.1554L1.60748 10.4026C2.0028 7.78921 3.4086 5.38305 5.49871 3.73459ZM1.54311 10.8828L2.59498 11.0195L7.30254 11.6331C7.29395 11.756 7.28707 11.8797 7.28707 11.9983C7.28707 13.0742 7.65489 14.1124 8.32521 14.9511L6.38732 16.6828L3.99657 18.82C2.37493 16.9191 1.48373 14.5076 1.48373 12C1.48373 11.6236 1.50358 11.2498 1.54311 10.8828ZM11.9999 22.5162C9.08934 22.5162 6.30392 21.3036 4.31973 19.181L5.13787 18.4505L8.65106 15.3129C9.53535 16.2041 10.7436 16.7102 11.9992 16.7102C13.8469 16.7102 15.4968 15.6498 16.2694 13.9869L21.6568 16.1671C19.9905 20.0325 16.2264 22.5162 11.9999 22.5162Z'
          fill='url(#paint0_linear_12280_31568)'
          stroke='url(#paint1_linear_12280_31568)'
          strokeWidth='1.2'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_31568'
          x1='5.55569'
          y1='2.50015'
          x2='15.5813'
          y2='22.5942'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_31568'
          x1='5.55569'
          y1='2.50015'
          x2='15.5813'
          y2='22.5942'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_31568'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Diagram;
